import { Component } from '@angular/core';
import {SucursalLocationComponent} from "./sucursal-location/sucursal-location.component";

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [SucursalLocationComponent],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.css'
})
export class FooterComponent {

}
